(() => {
  const prefetched = new Set();
  const unsupportedConnection = navigator.connection && (navigator.connection.saveData || /2g/.test(navigator.connection.effectiveType || ''));
  const excludedPath = /\/(cart|checkout|checkouts|account|orders|search)(\/|$)/;
  const excludedParams = /[?&](filter|sort_by|variant|page|q|oseid|preview_theme_id)=/;

  if (unsupportedConnection) return;

  const canPrefetch = (anchor) => {
    if (!anchor || !anchor.href || anchor.target || anchor.hasAttribute('download')) return false;
    const url = new URL(anchor.href, window.location.href);
    if (url.origin !== window.location.origin) return false;
    if (url.href === window.location.href) return false;
    if (excludedPath.test(url.pathname) || excludedParams.test(url.search)) return false;
    return true;
  };

  const prefetch = (anchor) => {
    if (!canPrefetch(anchor)) return;
    const url = new URL(anchor.href, window.location.href);
    url.hash = '';
    const href = url.toString();
    if (prefetched.has(href)) return;
    prefetched.add(href);

    const link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = href;
    link.as = 'document';
    document.head.appendChild(link);
  };

  const onIntent = (event) => {
    const anchor = event.target.closest('a[href]');
    prefetch(anchor);
  };

  document.addEventListener('mouseover', onIntent, { passive: true });
  document.addEventListener('touchstart', onIntent, { passive: true });

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          prefetch(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '240px 0px' });

    window.addEventListener('load', () => {
      document.querySelectorAll('a[href]').forEach((anchor) => {
        if (canPrefetch(anchor)) observer.observe(anchor);
      });
    }, { once: true });
  }
})();
